import Swiper, { Navigation, Autoplay, Thumbs } from 'swiper';



Swiper.use([Navigation, Autoplay, Thumbs]);

import 'swiper/css';
import 'swiper/css/navigation';
(function ($) {
  let menuWidth = 1280;
  let subMenuClass =
    ".movex-main-menu .current-menu-item .sub-menu, .movex-main-menu .current-page-ancestor .sub-menu";
  let menuHeight = 168;
  let swiperEquipment = null;
  let swiperEquipmentThumb = null;
  let swiperGallery = null;
  let swiperEquipmentGallery = null;

  let details = null;
  let sections = null;
  let nav_items = null;

  $(document).ready(function () {
    $(".cta-1 > a").addClass("gtm-cta-1");
    $(".cta-2 > a").addClass("gtm-cta-2");

    if($(".slide-details").length){
      details = gsap.utils.toArray(".slide-details:not(:first-child)");
      sections = gsap.utils.toArray(".slide-details");
    }
    if($(".slide-navigation-item").length){
      nav_items = document.querySelectorAll(".slide-navigation-item");
    }    

    movexUpdateHash();
    $(window).on('hashchange', function (e) {
      console.log(location.hash);
      $('.movex-current-hash').removeClass('current-menu-item movex-current-hash');
      movexUpdateHash();
    });

    $('.sub-menu .menu-item a').click(function () {
      if ($(this).attr('href').indexOf("#") !== 0) {
        $('.movex-menu-open').removeClass('movex-menu-close');
        $('.movex-menu').removeClass('movex-menu-opened');
      }
    });

    $("#breadcrumbs a").addClass("gtm-breadcrumbs");
    $(".newsletter-form").on("submit", subscribeToNewsletter);
    $(document).on("click", ".movex-menu-open", movexOpenMenu);
    $(document).on(
      "click",
      ".movex-main-menu .menu > li.menu-item-has-children > a",
      movexHeaderOpenSubMenu
    );
    $(document).on("click", "#movex_search", movexOpenSearch);
    $(document).on("click", ".movex-top-menu .search a", movexOpenSearch);
    $(window).on("resize", movexResize);
    $(document).on("click", ".movex-modal", movexClosePopupOutside);

    $(window).scroll(function () {
      debounce(movexHandleScroll, 25);
    });

    if ($('.movex-fixed-chart').length) {
      let chart = document.getElementById('movex_fixed_chart');
      $('.movex-chart-scroll').on("scroll", function (e) {
        chart.scrollLeft = e.currentTarget.scrollLeft;
      });
    }

    if (window.scrollY > 1 && window.innerWidth > menuWidth) {
      $(".movex-menu").addClass("scrolled");
    }
    if ($(".movex-type-transport").length) {
      movexTransportTypesSlider();
    }
    if ($(".movex-testimonies-swiper").length) {
      movexTestimoniesSlider();
    }
    if ($(".single-jobs").length && $("#job_type").length) {
      $("#job_type").attr("value", $(".single-jobs h1").text());
    }

    $(".fancybox").fancybox({
      loop: true,
      buttons: ["slideShow", "fullScreen", "thumbs", "close"],
      thumbs: {
        autoStart: true, // Démarrer automatiquement l'aperçu
      },
      closeButton: true,
    });

    $(document).on("keyup", "#movex-searchpage-input", function () {
      let keyword = "";
      let lang = "/";
      /*if($('#movex_search_form input[name="lang"]').val() == 'fr'){
                  lang = '/' + $('#movex_search_form input[name="lang"]').val();
              }*/
      if ($(this).val() != "") {
        keyword = lang + "?s=" + $(this).val();
      }
      $("#movex_search_form").attr("action", keyword);
    });

    $("#movex-search-input").keyup(delay(ajaxSearch, 500));

    $("#movex-search-input").on("search", ajaxClearSearch);

    document.addEventListener("wpcf7mailsent", contactFormRedirection, false);

    let popup_cookie = getCookie("zonzini-popup");
    if ($("#zonzini_popup").length && !popup_cookie) {
      $(".movex-modal-close").bind("click", function (e) {
        movexCloseModal();
      });

      $.ajax({
        beforeSend: function () { },
        url: ajaxurl,
        type: "post",
        data: { action: "movex_zonzini_popup" },
        success: function (data) {
          if (data) {
            $("body").addClass("overflow-hidden");
            $(".movex-modal").addClass("show");
            $(".movex-modal-content").html(data);
          }
        },
      });
    }
    const $toggleUs = $(".toggle-us");
    const $toggleUe = $(".toggle-ue");

    $toggleUs.click(function () {
      $toggleUs.addClass("toggle-active");
      $toggleUe.removeClass("toggle-active");
      $(".toggle-v-us").css('display', 'flex');
      $(".toggle-v-ue").hide();
    });

    $toggleUe.click(function () {
      $toggleUe.addClass("toggle-active");
      $toggleUs.removeClass("toggle-active");
      $(".toggle-v-ue").css('display', 'flex');
      $(".toggle-v-us").hide();

    });

    if ($('.mySwiper').length) {
      swiperSingleEquipmentThumb();
    }
    if ($('.mySwiper2').length) {
      swiperSingleEquipment();
    }

    if ($('.swiper-resource-equipment').length) {
      swiperRessourceEquipment();
    }

    if ($('.mySwiperEquipment').length) {
      swiperInitEquipmentGallery();
    }
    if ($('.mySwiperGallery').length) {
      swiperInitGallery();
    }

    if($('.flexible-gallery-modal').length) {
      $('.flexible-gallery .flexible-gallery-modal').click(function(e) {
        if(!$('.flexible-gallery .flexible-gallery-modal').hasClass('modal-closed')) {
          var container = $(".flexible-gallery-modal-video");

          if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.flexible-gallery .flexible-gallery-modal').toggleClass('modal-closed');
            $('.flexible-gallery-modal-video').attr('src', '');
          }
        }
      });

      $('.flexible-gallery .gallery .gallery-item-video').click(function(e) {
        if($(this).data('video-url')) {
          $('.flexible-gallery-modal-video').attr('src', $(this).data('video-url'));
          $('.flexible-gallery .flexible-gallery-modal').toggleClass('modal-closed');
        }
      });
    };

    if($('.flexible-related-app').length) {
      if(window.innerWidth >= 768) {
        $('.flexible-related-app .slide-details').each(function(){
          $(this).attr('open', 'true');
        });
      }
      
      $(window).on("resize", function(){
        if(window.innerWidth >= 768) {
          $('.flexible-related-app .slide-details').each(function(){
            $(this).attr('open', 'true');
          });
        }
      });

      nav_items.forEach(item => {
        item.addEventListener('click', scrollToSlide);
      });

      gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

      let mm = gsap.matchMedia();

      // add a media query. When it matches, the associated function will run
      mm.add("(min-width: 768px)", () => {
        // create scrollTrigger for each content section
        // to set the navigation link active depending on the active section 
        sections.forEach((section,index)=> {
          let navItemToTrigger = '#to-slide'+(index+1);
          
          ScrollTrigger.create({
            trigger:section,
            start:"top center",
            end: "bottom center",
            toggleClass:{
              targets: navItemToTrigger,
              className:"active"
            },
            onToggle: self=>{
              if(self.isActive){
                nav_items.forEach(el => el.classList.remove("active"));
                document.querySelector(navItemToTrigger).classList.add('active');
              }
            }
          })
        });
      });
    }

    const urlParams = new URLSearchParams(window.location.search);
    let queryStringMovex = urlParams.get('equipment_movex');
    let queryStringZonzini = urlParams.get('equipment_zonzini');
    setTimeout(() => {
      if (queryStringMovex && $('select[name="choice-product"]').length) {
        $('select[name="choice-product"]').val('Movex').change();
        $('#movex-equipment').show();
        $('#zonzini-equipment').hide();
      }
      if (queryStringZonzini && $('select[name="choice-product"]').length) {
        $('select[name="choice-product"]').val('Zonzini').change();
        $('#movex-equipment').hide();
        $('#zonzini-equipment').show();
      }
      if(queryStringMovex && $('select[name="equipment_movex"]').length && $('select[name="equipment_movex"] option[value="'+queryStringMovex+'"]').length){
        $('select[name="equipment_movex"]').val(queryStringMovex).change();
      }
      if(queryStringZonzini && $('select[name="equipment_zonzini"]').length && $('select[name="equipment_zonzini"] option[value="'+queryStringZonzini+'"]').length){
        $('select[name="equipment_zonzini"]').val(queryStringZonzini).change();
      }
    }, "1000");
  });

  $(window).on("load", function () {
    initLeonardGTMTracking();
  });

  function movexUpdateHash() {
    if (location.hash && $('a[href*="' + location.hash + '"]').length) {
      $('a[href*="' + location.hash + '"]').parents('li').addClass('current-menu-item movex-current-hash');
    }
  }
  function movexHandleScroll() {
    if (window.innerWidth >= menuWidth) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 50) {
        $(".movex-menu").removeClass("scrolled-top");
        $(".movex-menu").addClass("scrolled");
      } else {
        if (scrollTop > 50) {
          if ($(subMenuClass).length) {
            $(".movex-menu").addClass("scrolled-top");
          }
        }
      }
      if (scrollTop == 0) {
        $(".movex-menu").removeClass("scrolled");
        $(".movex-menu").removeClass("scrolled-top");
      }
      //oldScrollY = scrollTop <= 0 ? 0 : scrollTop;
    }
  }
  let chartFixed = document.querySelector('.movex-fixed-chart');
  let chart = document.querySelector('#comparison-chart');
  function movexVisibileChart() {
    console.log(chart.getBoundingClientRect());
    if (chartFixed.getBoundingClientRect().top <= menuHeight && chart.getBoundingClientRect().bottom > menuHeight) {
      chartFixed.classList.add('scrolled');
    }
    if (chart.getBoundingClientRect().bottom <= menuHeight || chart.getBoundingClientRect().top > -10) {
      chartFixed.classList.remove('scrolled');
    }
  }

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }


  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function ajaxSearch(e) {
    let perPage = 3;
    let paginate = 0;
    if (e.target.id == "movex-searchpage-input") {
      perPage = 12;
      paginate = 1;
    }
    if ($(this).val() == "") {
      ajaxClearSearch(e);
    } else {
      $.ajax({
        beforeSend: function () {
          $(".search-loading").removeClass("hidden");
        },
        url: ajaxurl,
        type: "post",
        data: {
          action: "movex_search_results",
          keyword: $(this).val(),
          perPage: perPage,
          paginate: paginate,
        },
        success: function (data) {
          if (e.target.id == "movex-searchpage-input") {
            jQuery("#movex_searchpage_results").html(data);
          } else {
            jQuery("#movex_search_results").html(data);
          }

          $(".search-loading").addClass("hidden");
        },
      });
    }
  }

  function contactFormRedirection() {
    var redirectUrl = $("input[name=redirect_url]").val();

    if (redirectUrl != undefined) {
      window.location = redirectUrl;
    }
    if ($('#zonzini_popup').length) {
      setCookie("zonzini-popup", 1, 30);
    }
  }

  function ajaxClearSearch(e) {
    if (e.target.id == "movex-searchpage-input") {
      jQuery("#movex_searchpage_results").empty();
    } else {
      jQuery("#movex_search_results").empty();
    }
  }

  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId = setTimeout(function () {
      method();
    }, delay);
  }

  function delay(callback, ms) {
    var timer = 0;
    return function () {
      var context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  function movexOpenMenu() {
    $("header.movex-menu").toggleClass("movex-menu-opened");
    $(".movex-menu-open").toggleClass("movex-menu-close");
    $("body").toggleClass('opened');
  }

  function movexHeaderOpenSubMenu(e) {
    if (window.innerWidth < menuWidth) {
      e.preventDefault();
      movexOpenSubMenu(this);
    }
  }

  function movexCloseModal() {
    $('.movex-modal').removeClass('show');
    $('body').removeClass('overflow-hidden');
    //setCookie("zonzini-popup", 1, 30);
  }
  function movexClosePopupOutside(e) {
    if (e.target != this) return;
    movexCloseModal();
  }

  function movexTestimoniesSlider() {
    let swiperTestimoniesTypeSlider = new Swiper(".movex-testimonies-swiper", {
      navigation: {
        nextEl: ".testimonies-next",
        prevEl: ".testimonies-prev",
      },

      nextButton: ".testimonies-next",
      prevButton: ".testimonies-prev",

      allowSlideNext: true,
      allowSlidePrev: true,

      speed: 400,
      initialSlide: 0,
      direction: "horizontal",
      loop: true,
      autoplay: 5000,

      effect: "slide",

      slidesPerView: 1,

      centeredSlides: true,

      grabCursor: true,
    });
  }

  function movexOpenSubMenu(el) {
    let allSubMenu = $(el)
      .parent()
      .parent()
      .find(".sub-menu")
      .not($(el).parent().find(".sub-menu"));
    let subMenuSelected = $(el).parent().find(".sub-menu");
    allSubMenu.removeClass("sub-menu-opened");
    subMenuSelected.toggleClass("sub-menu-opened");

    if ($(".movex-footer-menu .menu > li.current-page-ancestor").length) {
      $(
        ".movex-footer-menu .menu > li.current-page-ancestor .sub-menu"
      ).addClass("sub-menu-load");
    }

    $(el)
      .parent()
      .parent()
      .find("a")
      .not($(el))
      .removeClass("movex-sub-menu-selected");
    $(el).toggleClass("movex-sub-menu-selected");
  }

  function movexOpenSearch(e) {
    e.preventDefault();
    $("header.movex-menu").removeClass("movex-menu-opened");
    $("body").removeClass("opened");
    $(".movex-menu-open").removeClass("movex-menu-close");
    $("header.movex-menu").toggleClass("search-opened");
  }

  function movexResize(e) {
    let winWidth = window.innerWidth;
    if (winWidth > menuWidth) {
      $(".movex-main-menu .sub-menu").removeClass("sub-menu-opened");
      $(".movex-main-menu .menu > li > a").removeClass(
        "movex-sub-menu-selected"
      );
      $(".movex-menu-open").removeClass("movex-menu-close");
      $("header.movex-menu").removeClass("movex-menu-opened");
      $("body").removeClass("opened");
    } else {
      $(".movex-main-menu .sub-menu").removeAttr("style");
    }
  }

  // Set cookie information
  //
  // @return Void
  function setCookie(cookie_name, value, expiration_days) {
    var expiration_date = new Date();
    expiration_date.setDate(expiration_date.getDate() + expiration_days);

    var cookie_value =
      escape(value) +
      (expiration_days == null
        ? ""
        : "; expires=" + expiration_date.toUTCString()) +
      "; path=/";
    document.cookie = cookie_name + "=" + cookie_value;
  }

  // Get cookie information
  //
  // @return String || undefined
  function getCookie(cookie_name) {
    var cookie_value = document.cookie;
    var cookie_start = cookie_value.indexOf(" " + cookie_name + "=");

    if (cookie_start == -1)
      cookie_start = cookie_value.indexOf(cookie_name + "=");

    if (cookie_start == -1) {
      cookie_value = null;
    } else {
      cookie_start = cookie_value.indexOf("=", cookie_start) + 1;
      var c_end = cookie_value.indexOf(";", cookie_start);

      if (c_end == -1) c_end = cookie_value.length;

      cookie_value = unescape(cookie_value.substring(cookie_start, c_end));
    }

    return cookie_value;
  }


  // swiper equipment
  function swiperInitEquipmentGallery() {
    var numberOfSlides = $(".mySwiperEquipment .swiper-slide").length;

    var swiperEquipmentGallery = new Swiper(".mySwiperEquipment", {
      slidesPerView: 1,
      breakpoints: {
        640: {
          slidesPerView: Math.min(numberOfSlides, 2),
        },
        1024: {
          slidesPerView: Math.min(numberOfSlides, 3),
        },
      },
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
  function swiperInitGallery() {
    swiperGallery = new Swiper(".mySwiperGallery", {
      breakpoints: {
        600: {
          slidesPerView: 1,
        },
        601: {
          slidesPerView: 1.5,
        },
        1024: {
          slidesPerView: 3.5,
        },
      },
      loop: true,
      spaceBetween: 30,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  function swiperSingleEquipmentThumb() {
    swiperEquipmentThumb = new Swiper(".mySwiper", {
      // loop: true,
      spaceBetween: 10,
      slidesPerView: 4,
      //freeMode: true,
      //watchSlidesProgress: true,
    });
  }
  function swiperSingleEquipment() {
    swiperEquipment = new Swiper(".mySwiper2", {
      //loop: true,
      spaceBetween: 10,
      //watchSlidesProgress: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiperEquipmentThumb,
      },
    });
  }
  function swiperRessourceEquipment() {
    swiperEquipment = new Swiper(".swiper-resource-equipment", {
      spaceBetween: 20,
      slidesPerView: 1,
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiperEquipmentThumb,
      },
    });
  }

  // Chart automatic opening
  $(document).ready(function () {
    var $movexDetails = $(".movex-details-open");
    var $summaryElement = $movexDetails.find("summary");

    $summaryElement.on("click", function () {
      var $detailsElement = $(this).parent(".movex-details-open");
      $detailsElement.toggleAttr("open");
    });
  });

  /**
   * Launches the registration at the Mailchimp newsletter.
   */
  function subscribeToNewsletter(e) {
    let $form = $(this);
    $.ajax({
      beforeSend: function () {
        $form.find(".success, .error").addClass("hidden");
        $form.find("input").attr("disabled", true);
      },
      url: ajaxurl,
      type: "post",
      data: {
        action: "movex_trigger_newsletter_subscribe",
        email: $form.find('input[name="newsletter-email"]').val(),
        language: $form.find('input[name="current_lang"]').val(),
      },
      success: function (data) {
        $form.find("input").attr("disabled", false);
        if (data == "1") {
          $form.find(".success").removeClass("hidden");
        } else {
          $form.find(".error").removeClass("hidden");
        }
      },
    });
    return false;
  }

  var arrLeonardGTMTrackingFormPath = [
    "/find-dealer/",
    "/fr/trouver-un-detaillant/",
    "/become-dealer/",
    "/fr/devenir-detaillant/",
    "/request-a-quote/",
    "/fr/obtenir-soumission/",
    "/contact-us/",
    "/fr/contactez-nous/",
    "/careers/spontaneous-application/",
    "/fr/carrieres/candidature-spontanee/",
    "/fr/zonzini/obtenir-une-soumission/",
    "/zonzini/request-a-quote/",
    "/zonzini/",
    "/fr/zonzini/"
  ];

  function initLeonardGTMTracking() {
    // Track CTA pointing to a «Leads Form»
    // -------
    var arrLeonardGTMTrackingCTA = [];
    for (var i = 0; i < arrLeonardGTMTrackingFormPath.length; i++) {
      arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
    }

    // Custom CSS rules here
    // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

    $(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

    // Track «Leads form» submit button click
    // -------
    if(arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
      $("form button, form input[type=submit]").addClass("gtm-form-submited");
    }
  }
  
  /**
   * Function to change slide based on the navigation link clicked
   */
  function scrollToSlide(){
    let itemId = this.id;
    let slideNumber = itemId.slice(-1);
    let targetSlideId = 'is-slide'+slideNumber;
    let targetSlide = document.getElementById(targetSlideId);

    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: (targetSlide.offsetTop - 100),
      },
      ease: 'power3.inOut'
    });

    setActive(this);
  }

  /**
  * Function to set navigation links active
  * @param {Element} item 
  */
  function setActive(item) {
    nav_items.forEach(el => el.classList.remove("active"));
    item.classList.add("active");
  }
})(jQuery);

//form toggle product  

document.addEventListener("DOMContentLoaded", function () {
  var choiceProductField = document.querySelector('[name="choice-product"]');
  var movexEquipmentField = document.getElementById("movex-equipment");
  var zonziniEquipmentField = document.getElementById("zonzini-equipment");

  function toggleEquipmentFields() {
    if(movexEquipmentField) {
      movexEquipmentField.style.display = choiceProductField.value === "Movex" ? "block" : "none";
    }
    if(zonziniEquipmentField) {
      zonziniEquipmentField.style.display = choiceProductField.value === "Zonzini" ? "block" : "none";
    }
  }

  toggleEquipmentFields();

  if(choiceProductField) {
    choiceProductField.addEventListener("change", toggleEquipmentFields);
  }
});



